import { Component} from "@angular/core";
import {ViewController, NavParams, Events} from "ionic-angular";
import {ToastService} from "../../core/toast.service";
import {JobService} from "../../../pages/job/shared/job.service";
import {Job} from "../../../pages/job/shared/job.model";

@Component({
  templateUrl: 'rating-modal.component.html',
})
export class RatingModal {
  job: Job;
  stars = [1, 2, 3, 4, 5];

  constructor(private viewCtrl: ViewController,
              params: NavParams,
              private jobService: JobService,
              private toast: ToastService,
              private events: Events) {
    this.job = params.get('job');
  }

  dismiss() {
    return this.viewCtrl.dismiss();
  }

  saveRating(job, rating){
    this.job.rating = rating;
    this.jobService.rateJob(this.job)
      .subscribe(
        (res) => {
          this.toast.show(res.message);
          this.events.publish('job:updated');
        }
      );
  }

  submitReview() {
    this.dismiss().then(() => {
      this.jobService.reviewJob(this.job)
        .subscribe(
          (res) => {
            this.toast.show(res.message);
            this.events.publish('job:updated');
          }
        );
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/components/rating-modal/rating-modal.component.ts